module.exports = __webpack_public_path__ + "img/complaints.a2a38522.svg";